import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface toastInterface {
  toastMessage: string;
  toastMessageType: string;
  timeout?: number;
}
interface UserState {
  payloadData: any;
  requestPayload: any;
  instrumentationData: any;
  toastData: toastInterface;
  fieldErrorData: any;
  idv_price: number;
}

const initialState: UserState = {
  payloadData: {},
  requestPayload: {},
  instrumentationData: {},
  idv_price: 0,
  toastData: {
    toastMessage: "",
    toastMessageType: "",
    timeout: 3000
  },
  fieldErrorData: {
    message: "",
    componentName: "",
    show: false
  }
};

const GlobalSlice = createSlice({
  name: "globalState",
  initialState,
  reducers: {
    setData(state, action) {
      return { ...state, ...action.payload };
    },
    setPayloadData(state, action) {
      return {
        ...state,
        payloadData: { ...state.payloadData, ...action.payload }
      };
    },
    setInstrumentationData(state, action) {
      return {
        ...state,
        instrumentationData: { ...state.instrumentationData, ...action.payload }
      };
    },
    setRequestPayload(state, action) {
      return {
        ...state,
        requestPayload: { ...state.requestPayload, ...action.payload }
      };
    },
    setToastData(state, action: PayloadAction<toastInterface>) {
      return {
        ...state,
        toastData: { ...state.toastData, ...action.payload }
      };
    },
    setFieldErrorData(state, action) {
      return {
        ...state,
        fieldErrorData: { ...state.fieldErrorData, ...action.payload }
      };
    },
    removePayloadKey(state, action) {
      const keyToRemove = action.payload;

      if (keyToRemove in state.payloadData) {
        const { [keyToRemove]: _, ...remainingPayloadData } = state.payloadData;

        return {
          ...state,
          payloadData: remainingPayloadData
        };
      }
      return state;
    },
    removeInstrumentationKey(state, action) {
      const keyToRemove = action.payload;

      if (keyToRemove in state.instrumentationData) {
        const { [keyToRemove]: _, ...remainingInstrumentationData } = state.instrumentationData;

        return {
          ...state,
          instrumentationData: remainingInstrumentationData
        };
      }
      return state;
    },
    resetState() {
      return { ...initialState };
    },
    deleteGlobalKey: (state, action) => {
      const { key } = action.payload;
      if (key in state) {
        delete state[key];
      }
    },
    resetToastData(state) {
      return {
        ...state,
        toastData: { ...initialState.toastData }
      };
    },
    resetFieldErrorData(state) {
      return {
        ...state,
        fieldErrorData: { ...initialState.fieldErrorData }
      };
    },
    resetPayload(state, action) {
      return {
        ...state,
        payloadData: {}
      };
    },
    resetInstrumentation(state, action) {
      return {
        ...state,
        instrumentationData: {}
      };
    }
  }
});

export const {
  setData,
  setPayloadData,
  setInstrumentationData,
  setRequestPayload,
  deleteGlobalKey,
  removePayloadKey,
  removeInstrumentationKey,
  resetState,
  setToastData,
  resetToastData,
  setFieldErrorData,
  resetFieldErrorData,
  resetPayload,
  resetInstrumentation
} = GlobalSlice.actions;
export default GlobalSlice.reducer;
